import { Address } from "./address";
import { BaseProperties } from "./base.interface";
import { FilesOutput } from "./files";
import { UsersOutput } from "./users";

export interface SocialLinks {
  x?: string;
  instagram?: string;
  tiktok?: string;
  facebook?: string;
  googleProfile?: string;
}

export enum UserRoles {
  OWNER = "OWNER",
  ADMIN = "ADMIN",
  MANAGER = "MANAGER",
  MEMBER = "MEMBER",
}

type OrganizationUser = {
  role: UserRoles;
  user: string;
};

export type OrganizationUserObj = {
  role: UserRoles;
  user: UsersOutput;
};

export interface OrganizationsInput {
  name: string;
  phoneNumber?: string;
  email?: string;
  internationalCode?: string;
  ddd?: string;
  address?: Address;
  users?: OrganizationUser[];
  document?: string;
  dueDay?: number;
  fileId?: string;
  website?: string;
  socialLinks?: SocialLinks;
}

export interface OrganizationPlan extends BaseProperties {
  planId: string;
  startDate: Date;
  endDate: Date;
  allowAdditional: boolean;
  organizationId: string;
  activePlan: boolean;
}

export interface OrganizationsOutput
  extends BaseProperties,
    Omit<OrganizationsInput, "users"> {
  users: OrganizationUserObj[];
  plan: OrganizationPlan;
  file: FilesOutput;
  slug: string;
}

export const userRolesTranslations: Record<UserRoles, string> = {
  [UserRoles.ADMIN]: "Administrador",
  [UserRoles.OWNER]: "Dono",
  [UserRoles.MANAGER]: "Gerente",
  [UserRoles.MEMBER]: "Membro",
};
